import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=e49e9cba&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=e49e9cba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49e9cba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e49e9cba')) {
      api.createRecord('e49e9cba', component.options)
    } else {
      api.reload('e49e9cba', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=e49e9cba&scoped=true&", function () {
      api.rerender('e49e9cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/checkbox.vue"
export default component.exports